// extracted by mini-css-extract-plugin
module.exports = {"geosuggest-popup":"_373a3719ba--geosuggest-popup--j8epB","suggestion-list":"_373a3719ba--suggestion-list--NRzbC"};